import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73d08970")

_pushScopeId("data-v-73d08970")
const _hoisted_1 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_2 = { class: "kn-list-item-text" }
const _hoisted_3 = { class: "p-d-flex p-flex-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionSelectCNDialogDsecriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.destinationSelectionTitle')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary p-ml-auto",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_Listbox, {
        id: "cross-navigation-document-list",
        class: "p-m-2",
        options: _ctx.crossNavigationDocuments,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigationSelected($event.value))),
        "data-test": "kpi-list"
      }, {
        option: _withId((slotProps) => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", null, _toDisplayString(slotProps.option.crossName ?? slotProps.option.crossText), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["options"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})